<template>
  <admin-layout
    :title="`Mapeamento de campos | {{entity_translate[entity]}} `"
    menu="Mapeamento de campos"
  >
    <div class="row">
      <div class="col-lg-8 col-xs-12">
        <h3>
          Entidade {{entity_translate[entity]}}
        </h3>
      </div>
      <div class="col-lg-4 col-xs-12">
        <button
          @click="showForm(false)"
          class="btn-new-job"
        >
          <font-awesome-icon icon="plus" />
          Cadastrar novo campo
        </button>
      </div>
    </div>
    <div v-if="field_mapping_entities.length > 0">
      <div class="row field_uni header_field">
        <div class="col-lg-2">
          Nome
        </div>
        <div class="col-lg-2">
          Obrigatório
        </div>

        <div class="col-lg-2">
          Tipo
        </div>
        <div class="col-lg-2">
          Escondido
        </div>
        <div class="col-lg-2">
          Valor Padrão
        </div>
      </div>

      <draggable
        :list="field_mapping_entities"
        :disabled="false"
        v-bind="dragOptions"
        ghost-class="ghost"
        class="row"
        @change="changeColumn"
      >
        <div
          v-for="field in field_mapping_entities"
          class="col-lg-12 "
          :key="field.id"
        >
          <div class="row field_uni">
            <div class="col-lg-2">
              {{field.parameters.name}}
            </div>
            <div class="col-lg-2">
              {{field.parameters.required ? "Sim" : "Não"}}
            </div>
            <div class="col-lg-2">
              {{type_field_translate[field.parameters.type_field]}}
            </div>
            <div class="col-lg-2">
              {{field.parameters.hidden  ? "Sim" : "Não"}}
            </div>
            <div class="col-lg-2">
              {{field.parameters.value_field}}
            </div>

            <div class="col-lg-2">

              <font-awesome-icon
                @click="remove(field.id)"
                class="right ml-2 mr-2"
                icon="times"
              />
              <font-awesome-icon
                @click="showForm(field)"
                class="right ml-2 mr-2"
                icon="pencil-alt"
              />
            </div>
          </div>
        </div>
      </draggable>

    </div>
    <div
      v-if="field_mapping_entities.length > 2"
      class="row pl-3"
    >
      <div class="col-lg-12">
        <span>
          <b>*</b> Clique e arraste para mudar a ordem dos campos
        </span>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import FielMappingForm from "components/FieldMapping/Form.vue";
import draggable from "vuedraggable";
export default {
  components: { draggable },
  props: ["entity"],
  data: () => ({
    field_mapping_entities: [],
  }),
  mounted() {
    this.loadFields();
  },
  methods: {
    remove(id) {
      let conf = confirm("Tem certeza que deseja deletar esse campo?");
      if (!conf) return;
      axios
        .delete("/recruiters/field_mapping_entities/" + this.entity + "/" + id)
        .then((response) => {
          this.loadFields();
        });
    },
    loadFields() {
      axios
        .get("/recruiters/field_mapping_entities/" + this.entity)
        .then((response) => {
          this.field_mapping_entities = response.data;
        });
    },
    changeColumn() {
      axios
        .put(
          "/recruiters/field_mapping_entities/" + this.entity + "/change_order",
          {
            field_mapping_entities: {
              itens: this.field_mapping_entities,
            },
          }
        )
        .then((response) => {
          console.log(response);
        });
    },
    showForm(field) {
      console.log(field);
      this.$modal.show(
        FielMappingForm,
        {
          entity: this.entity,
          field_mapping: field,
        },
        {
          width: "50%",
          height: "auto",
          scrollable: true,
        }
      );
    },
  },
  computed: {
    entity_translate() {
      return {
        candidates: "Candidatos",
      };
    },
    type_field_translate() {
      return {
        text: "Texto",
        number: "Number",
      };
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
};
</script>
